// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bcJi","footer":"styles_footer__1aPiH"};